__webpack_require__.p = "https://stg.parcelhub.ae/accountingmasters/officeTypes/";